<template>
    <div class="content-body pd-10">
        <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
            <div>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                        <li class="breadcrumb-item">
                            <router-link to="/accounts/">Accounts Services</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">Account Statements</li>
                    </ol>
                </nav>
                <h4 class="mg-b-0 tx-spacing--1">Account Statements</h4>
            </div>
            <div class="d-none d-md-block">
<!--                <download-excel-->
<!--                        :data="this.trans"-->
<!--                        class="btn btn-sm pd-x-15 btn-white btn-uppercase">-->
<!--                    <PrinterIcon class="mg-r-5"/>-->
<!--                    Download Excel-->
<!--                </download-excel>-->
<!--                <download-excel-->
<!--                        type="csv"-->
<!--                        :data="this.trans"-->
<!--                        class="btn btn-sm pd-x-15 btn-white btn-uppercase">-->
<!--                    <PrinterIcon class="mg-r-5"/>-->
<!--                    Download CSV-->
<!--                </download-excel>-->
                <b-button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" v-b-modal="'querystatement'">
                    <plus-icon class="wd-10 mg-r-5"></plus-icon>
                    Download Statements
                </b-button>

            </div>
        </div>
        <view-account-card></view-account-card>
        <hr>
        <statements-table
                :accounts="accoption"
                :trans="[]"
                :is-busy="account.accountLoading">
        </statements-table>

        <b-modal id="querystatement" ref="query-modal" :hide-header="true" :hide-footer="true" :centered="true">
            <div class="modal-body">
                <a href="" role="button" class="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </a>

                <div>
                    <h4>Query Account Statements</h4>
                    <p class="tx-color-03">Query Account Statements</p>
                    <b-form>
                        <b-form-group label="Pick Date Range:">
                            <date-picker
                                    class="date"
                                    v-model="query.date"
                                    type="date"
                                    range
                                    value-type="DD-MMM-YYYY"
                                    format="DD/MMM/YYYY">
                            </date-picker>
                        </b-form-group>

                        <b-form-group label="Select Account:">
                            <b-form-select
                                    id="narration"
                                    v-model="query.accnumber"
                                    :options="accoptions"
                                    required
                            ></b-form-select>

                        </b-form-group>




                        <b-button v-if="account.accountLoading === true" disabled class="btn-secondary btn-brand-02 btn-block">
                            <span  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </b-button>
                        <download-excel v-else
                                class = "btn btn-secondary btn-block btn-sm"
                                :fetch   = "statement"
                                type    = "excel">
                            Generate Statements
                        </download-excel>
<!--                        <b-button  type="submit" class="btn btn-secondary btn-block btn-sm">Submit</b-button>-->

                    </b-form>


                </div>
            </div><!-- modal-body -->
        </b-modal>

    </div>
</template>

<script>
    import {PlusIcon} from 'vue-feather-icons'
    import DatePicker from "vue2-datepicker"
    import ViewAccountCard from "../../components/card/ViewAccountCard";
    import StatementsTable from "../../components/table/StatementsTable";
    import {mapGetters, mapState} from "vuex";
    import 'vue2-datepicker/index.css';


    export default {

        data() {

            return {
                accounts: ['loading...'],
                items: [],
                accoption: [],
                query: {
                    date: '',
                },
                busy: false
            }
        },
        components: {
            ViewAccountCard,
            StatementsTable,
            DatePicker,
            PlusIcon
        },
        computed: {
            trans() {
                return this.account.statements
            },
            accoptions: function () {
                return this.$store.state.account.accountoption
            },
            ...mapGetters('account', ['getByAccount']),
            ...mapState(['transactions', 'account', 'auth']),
        },
        methods: {
            statement: async function () {
                console.log(this.query.date)
                const payload = {
                    startdate: this.query.date[0],
                    enddate: this.query.date[1],
                    accountnumber: this.query.accnumber.accountnumber,
                    firstname: this.auth.response.name,
                    email: this.auth.response.email
                };
              console.log(payload)
              const resp = await this.$store.dispatch("account/getAccountStatements", payload, {root: false});
                this.$refs['query-modal'].hide();
                this.$swal({
                    title: 'Success',
                    text: 'Your account statement has been forwarded to your registered email',
                    icon: 'success',
                    showCancelButton: false,
                    confirmButtonText: 'Ok'
                });
                return resp;
            },
            onSubmit: async function () {
                console.log(this.query);
                this.$refs['query-modal'].hide();
                this.account.allActivities.filter(trans => trans.account === this.query.accnumber);
            },
            getAccount: async function () {
                if (JSON.stringify(this.account.allAccounts) === '[]') {
                    let payload = {customerid: this.auth.response.customerid};
                    await this.$store.dispatch("account/getAllAccount", payload, {root: false});
                }
                this.accoption = this.account.allAccounts.map(acc => acc.accountno);
            }


        },
        mounted() {
            this.getAccount();
        }
    }


</script>

<style scoped>
    .date{
        width: 100%;
    }

</style>
